import { useEffect, useState } from 'react';

import { useLocation } from 'react-router-dom';

import { Box, Grid, Typography } from '@mui/material';

import { useDispatch, useSelector } from 'react-redux';
import { getSecondLevelImages } from 'store/slices/healthContent';
import { DefaultRootStateProps } from 'types';
import CardRatings from './CardRatings';
import TableProducts from '../TableProducts';
import { useIntl } from 'react-intl';
import { ResumenProducts } from 'types/components/shared';
import { HeaderWrapperView } from '../components/CardWrapper';
import ViewGridComponent from '../components/ViewGrid';

const Images = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const [secondLevel, setSecondLevel] = useState<any>();
    const [typeScore, setTypeScore] = useState<'Good' | 'Fair' | 'Poor' | string>('');
    const [products, setProducts] = useState([]);
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const { secondLevelImages, loading } = useSelector((state: DefaultRootStateProps) => state.healthContent);

    const intl = useIntl();

    useEffect(() => {
        const idMerchant = new URLSearchParams(location.search).get('idMerchant');
        dispatch(getSecondLevelImages(Number(idMerchant) ?? 0));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    useEffect(() => {
        setSecondLevel(secondLevelImages);
    }, [secondLevelImages]);

    useEffect(() => {
        if (typeScore === 'Good') {
            setProducts(secondLevel?.metricGood);
        } else if (typeScore === 'Fair') {
            setProducts(secondLevel?.metricFair);
        } else if (typeScore === 'Poor') {
            setProducts(secondLevel?.metricPoor);
        } else {
            setProducts(secondLevel?.metricGood);
        }
    }, [secondLevel?.metricFair, secondLevel?.metricGood, secondLevel?.metricPoor, typeScore]);

    const sumaValores = (): number => {
        if (!secondLevel || !secondLevel.resume) {
            return 0;
        }
        const totalProductsSum = secondLevel.resume.reduce(
            (accumulator: number, currentValue: { totalProducts: number }) => accumulator + currentValue.totalProducts,
            0
        );
        return totalProductsSum;
    };

    return (
        <>
            <HeaderWrapperView title={intl.formatMessage({ id: 'images' })} dataToDownload={secondLevelImages} />
            <ViewGridComponent isLoading={loading && !secondLevel?.resume?.length}>
                {secondLevel?.resume
                    ?.toSorted((a: ResumenProducts, b: ResumenProducts) => a.metricConfigRangeId - b.metricConfigRangeId)
                    .map((resume: ResumenProducts) => (
                        <Grid item xs={12} sm={4} lg={12}>
                            <CardRatings resume={resume} sumaValores={sumaValores} setTypeScore={setTypeScore} typeScore={typeScore} />
                        </Grid>
                    ))}
                {products?.length === 0 ? (
                    <Box sx={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Typography variant="h3">{intl.formatMessage({ id: 'no_images_to_show' })}</Typography>
                    </Box>
                ) : (
                    <TableProducts products={products} typeReq="images" />
                )}
            </ViewGridComponent>
        </>
    );
};

export default Images;
